import {
  AnalyzeExperimentRequestBodyType,
  StatSigViewType,
} from "@intelligems/ig-types";

import { SitewideDashboardFiltersDialog } from "./sitewideDashboardFilters";

export type IExperienceDashboardFilters = Pick<
  AnalyzeExperimentRequestBodyType,
  | "deviceType"
  | "visitorType"
  | "channels"
  | "customEvents"
  | "userBehavior"
  | "urlParam"
  | "countryCodes"
  | "maxZScore"
  | "discountIncludeType"
  | "testOrdersOnly"
  | "startTime"
  | "endTime"
  | "shippingExpensePerOrder"
  | "transactionFeePct"
  | "excludeIpAddresses"
> & {
  experienceId?: string;
  compareGroupA?: string;
  compareGroupB?: string;
  statSigView?: StatSigViewType;
  isZScoreEnabled: boolean;
};

export const initialDashboardFiltersState: IExperienceDashboardFilters = {
  experienceId: undefined,
  startTime: null,
  endTime: null,
  testOrdersOnly: null,
  compareGroupA: "",
  compareGroupB: "",
  discountIncludeType: 1,
  isZScoreEnabled: true,
  statSigView: "best",
  maxZScore: null,
  customEvents: [],
  countryCodes: [],
  deviceType: null,
  visitorType: null,
  shippingExpensePerOrder: null,
  transactionFeePct: null,
  excludeIpAddresses: [],
  channels: [],
  urlParam: {
    queryParam: null,
    queryParamValue: null,
    queryParamFilterType: null,
  },
  userBehavior: { viewedCheckout: null, addedToCart: null },
};

export type AnalyticsActiveFilterType = {
  key: keyof IExperienceDashboardFilters | keyof SitewideDashboardFiltersDialog;
  label: any;
  value: any;
};
